import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import BlockContent from "@sanity/block-content-to-react";
import { useMediaQuery } from "@uidotdev/usehooks";
import NavBarEN from "./NavBarEN";
import NavBarMobileEN from "./NavBarMobileEN";
import FooterEN from "./FooterEN";
import FormEN from "./FormEN";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function SinglePostEN() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const allDevices = useMediaQuery("only screen and (min-width : 769px)");
  const [singlePostEN, setSinglePost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${slug}"]{
            title,
            _id,
            slug,
            autor,
            mainImage{
                asset->{
                    _id,
                    url
                }
            },
            body
        }`
      )
      .then((data) => setSinglePost(data[0]))
      .catch(console.error);
  }, [slug]);

  if (!singlePostEN) return <div>Loading...</div>;

  return (
    <>
    {allDevices && (
        <NavBarEN />
    )}
      {isSmallDevice && (
          <NavBarMobileEN/>
    )}
    <main className="bg-white-100 min-h-screen px-4 md:p-12">
      <article className="container shadow-lg mx-auto bg-white-100 rounded-lg">
        <header className="relative">
          <div className="absolute h-full w-full flex items-center justify-center p-8">
            <div className="bg-white bg-opacity-75 rounded p-12">
              <h1 className="text-2xl lg:text-2xl mb-4">
                {singlePostEN.title}
              </h1>

            </div>
          </div>
          <img
            src={singlePostEN.mainImage.asset.url}
            alt={singlePostEN.title}
            className="w-full object-cover rounded-t"
            style={{ height: "400px" }}
          />
        </header>
        <div className="px-4 py-28 md:px-16 lg:px-48 py-12 lg:py-20 max-w-full">
          <BlockContent
            blocks={singlePostEN.body}
            projectId="krjmu28b"
            dataset="production"
          />
          <p className="text-gray-800 mb-2 mt-4">Author: {singlePostEN.autor}</p>
        </div>
      </article>
    </main>
    <FormEN />
    <FooterEN />
    </>
  );
}